import RecapNotesSection, { RecapNotesSectionProps } from "./RecapNotesSection";
import RecapTranscriptSection from "./RecapTranscriptSection";

const ScrollableRecapContent = (props: RecapNotesSectionProps) => {
  return (
    <>
      <RecapNotesSection {...props} />
      <RecapTranscriptSection />
    </>
  );
};

export default ScrollableRecapContent;
